import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PracticeControls = ({ 
  currentQuestion,
  totalQuestions,
  timeRemaining,
  isTimedMode,
  onPrevious,
  onNext,
  onEndSession,
  canGoNext,
  canGoPrevious
}) => {
  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hours > 0) {
      return `${hours}:${minutes?.toString()?.padStart(2, '0')}:${secs?.toString()?.padStart(2, '0')}`;
    }
    return `${minutes}:${secs?.toString()?.padStart(2, '0')}`;
  };

  const getTimeColor = () => {
    if (!isTimedMode) return 'text-muted-foreground';
    if (timeRemaining < 300) return 'text-error';
    if (timeRemaining < 900) return 'text-warning';
    return 'text-success';
  };

  return (
    <div className="bg-card border-t border-border sticky bottom-0 z-10">
      <div className="max-w-[1536px] mx-auto px-4 md:px-6 py-4">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 md:gap-6 w-full lg:w-auto">
            <div className="flex items-center gap-2">
              <Icon name="FileText" size={20} className="text-primary" />
              <span className="text-sm font-medium text-foreground">
                Question <span className="data-text">{currentQuestion}</span> of <span className="data-text">{totalQuestions}</span>
              </span>
            </div>

            {isTimedMode && (
              <div className="flex items-center gap-2">
                <Icon name="Clock" size={20} className={getTimeColor()} />
                <span className={`text-sm font-medium data-text ${getTimeColor()}`}>
                  {formatTime(timeRemaining)}
                </span>
              </div>
            )}

            <div className="flex items-center gap-2">
              <div className="w-32 md:w-48 h-2 bg-muted rounded-full overflow-hidden">
                <div 
                  className="h-full bg-primary transition-all duration-300"
                  style={{ width: `${(currentQuestion / totalQuestions) * 100}%` }}
                />
              </div>
              <span className="text-xs text-muted-foreground data-text">
                {Math.round((currentQuestion / totalQuestions) * 100)}%
              </span>
            </div>
          </div>

          <div className="flex items-center gap-3 w-full lg:w-auto">
            <Button
              variant="outline"
              onClick={onPrevious}
              disabled={!canGoPrevious}
              iconName="ChevronLeft"
              iconPosition="left"
              className="flex-1 lg:flex-initial"
            >
              Previous
            </Button>

            <Button
              variant="default"
              onClick={onNext}
              disabled={!canGoNext}
              iconName="ChevronRight"
              iconPosition="right"
              className="flex-1 lg:flex-initial"
            >
              {currentQuestion === totalQuestions ? 'Finish' : 'Next'}
            </Button>

            <Button
              variant="destructive"
              onClick={onEndSession}
              iconName="X"
              size="icon"
              className="lg:ml-3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PracticeControls;